module.exports = __webpack_public_path__ + "img/img_title_advantage_07.13f9364e.png";